import React, { CSSProperties, JSX } from "react";
import Util from "@/js/common/Util";

interface TextBoxProps {
    type?: string
    value?: string
    width?: number
    height?: number
    borderColor?: string
    borderOnColor?: string
    borderRadius?: number
    fontSize: number
    fontFamily?: string
    letterSpacing?: number
    color?: string
    offColor?: string
    maxLength?: number
    className?: string
    mode?: "readonly" | "disabled" | ""
    placeholder?: string
    iconEl?: JSX.Element
    inputClassName?: string
    onClickFunc?: Function
    onChangeFunc?: Function
    onKeyDown?: Function
    onKeyUp?: Function
    startIcon?: React.ReactNode
    debounced?: boolean
    debouncedSecond?: number
    style?: CSSProperties
}
const TextBox = ({
    type,
    value,
    width,
    height,
    borderColor,
    borderOnColor,
    borderRadius,
    fontSize,
    fontFamily,
    letterSpacing,
    color,
    offColor,
    maxLength,
    className,
    mode,
    placeholder,
    iconEl,
    inputClassName,
    onClickFunc,
    onChangeFunc,
    onKeyDown,
    onKeyUp,
    startIcon,
    style,
}: TextBoxProps) => {
    const inputRef = React.useRef<HTMLInputElement>(null);
    const [focusState, setFocusState] = React.useState<boolean>(false);
    const [hoverState, setHoverState] = React.useState<boolean>(false);

    const calcFontColor = () => {
        if (Util.isEmpty(value)) {
            return offColor;
        }
        if (mode === undefined || mode === null) {
            if (Util.isEmpty(color)) {
                return "#505050";
            } else {
                return color;
            }
        } else {
            if (Util.isEmpty(offColor)) {
                return "#222";
            } else {
                return offColor;
            }
        }
    }

    React.useLayoutEffect(() => {
        if (inputRef.current) {
            inputRef.current.style.setProperty('--placeholder-color', (offColor === undefined ? "#999999" : offColor));
            inputRef.current.style.setProperty('--placeholder-font-family', "fm-b");
        }
    }, [offColor])

    return (
        <div
            className={"dpFlx jcSb aiC bsBdb ofH olN " + (["disabled"].indexOf(mode || "") !== -1 ? "bgcF6F6F6 " : "") + (Util.isNotEmpty(className) ? className : "")}
            style={{
                ...style,
                width: Util.isEmpty(width) ? "100%" : width + "px",
                height: Util.isEmpty(height) ? "100%" : height + "px",
                lineHeight: Util.isEmpty(height) ? "100%" : height + "px",
                border: "1px solid",
                borderColor: (focusState || hoverState ? (Util.isEmpty(borderOnColor) ? "transparent" : borderOnColor) : (Util.isEmpty(borderColor) ? "transparent" : borderColor)),
                borderRadius: borderRadius ? borderRadius : "",
            }}
            onMouseOver={() => setHoverState(true)}
            onMouseOut={() => setHoverState(false)}
            onClick={() => {
                inputRef.current?.focus();
                if (onClickFunc) {
                    onClickFunc();
                }
            }}
        >
            {startIcon}
            <input
                ref={inputRef}
                type={type || "text"}
                value={value || ""}
                maxLength={maxLength || 50}
                style={{
                    fontVariant: "tabular-nums",
                    fontSize: fontSize + "px",
                    fontFamily: fontFamily ? fontFamily : "fm-b",
                    color: calcFontColor(),
                    letterSpacing: letterSpacing ? letterSpacing + "px" : ""
                }}
                className={"bgcTp bd0 olN w100p h100p bsBdb " + inputClassName + (["disabled", "readonly"].indexOf(mode || "") !== -1 ? " op100" : "")}
                onChange={(e) => {
                    if (onChangeFunc === undefined) {
                        return;
                    }
                    onChangeFunc(e.target.value);
                }}
                onKeyDown={(e) => {
                    if (onKeyDown === undefined) {
                        return;
                    }
                    onKeyDown(e);
                }}
                onKeyUp={(e) => {
                    if (onKeyUp === undefined) {
                        return;
                    }
                    onKeyUp(e);
                }}
                onFocus={() => setFocusState(true)}
                onBlur={() => setFocusState(false)}
                disabled={mode === "disabled"}
                readOnly={mode === "readonly"}
                placeholder={placeholder || ""}
            />
            {iconEl}
        </div>
    )
}
export default TextBox;